import { useEffect } from "react";

function StockReel() {
    const tradingViewScriptId = "tradingview-ticker-tape-widget-script";

    useEffect(() => {
        const script = document.createElement("script");
        script.id = tradingViewScriptId;
        script.src = "https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js";
        script.async = true;
        script.innerHTML = JSON.stringify({
            symbols: [
                {
                    proName: "FOREXCOM:SPXUSD",
                    title: "S&P 500",
                },
                {
                    proName: "FOREXCOM:NSXUSD",
                    title: "US 100",
                },
                {
                    description: "",
                    proName: "NASDAQ:TSLA",
                },
                {
                    description: "",
                    proName: "NASDAQ:AAPL",
                },
                {
                    description: "",
                    proName: "NASDAQ:NVDA",
                },
                {
                    description: "",
                    proName: "NASDAQ:META",
                },
                {
                    description: "",
                    proName: "NASDAQ:AMZN",
                },
            ],
            showSymbolLogo: true,
            colorTheme: "light",
            isTransparent: true,
            largeChartUrl: "",
            displayMode: "regular",
            locale: "en",
        });

        document.getElementById("tradingview-widget-container").appendChild(script);

        return () => {
            // clean up on unmount
            const scriptTagToRemove = document.getElementById(tradingViewScriptId);
            if (scriptTagToRemove) {
                scriptTagToRemove.remove();
            }
        };
    }, []);

    return (
        <div id="tradingview-widget-container">
            <div className="tradingview-widget-container__widget"></div>
        </div>
    );
}

export default StockReel;
